import { render, staticRenderFns } from "./EquipmentTabs.vue?vue&type=template&id=60e8b5ea"
import script from "./EquipmentTabs.vue?vue&type=script&lang=js"
export * from "./EquipmentTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports